import { Component, OnInit, Input, HostBinding, HostListener, ChangeDetectionStrategy, ElementRef } from '@angular/core';
import { GenericModalBroadcasterService, GMBEventType } from './services/generic-modal-broadcaster.service';
import { IGenericModalOptions } from './igeneric-modal-options';

@Component({
    selector: 'da-generic-modal',
    templateUrl: './generic-modal.component.html',
    styleUrls: ['./generic-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenericModalComponent implements OnInit {
    @Input() hasError = false;
    @Input() isCloseable = false;
    @Input() template;
    @Input() options: IGenericModalOptions;
    @Input() modalID: string;
    @Input() additionalClass = '';
    @Input() isWarning = false;
    @Input() isCookie = false;
    @Input() isLogin = false;
    @Input() isNewCourses = false;
    @Input() class = '';
    private element: any;

    @HostListener('window:keydown', ['$event'])
    onKeyDown($event): void {
        if ($event.keyCode === 27 && !this.isCookie) {
            this.close();
        }
    }

    constructor(private _genericModalBroadcasterService: GenericModalBroadcasterService, private el: ElementRef) {
        this.element = el.nativeElement;
    }

    ngOnInit() {
        // ensure id attribute exists
        if (this.modalID) {
            const bodyTag = document.body;
            bodyTag.classList.add('open-modal');
        }
    }

    ngOnDestroy(): void {
        this.element.remove();
        const bodyTag = document.body;
        bodyTag.classList.remove('open-modal');
    }

    close() {
        if (this.modalID) {
            this._genericModalBroadcasterService.fire(GMBEventType.CLOSE, this.modalID);
            const bodyTag = document.body;
            bodyTag.classList.remove('open-modal');
        }
    }

    closeClickOutside() {
        if (this.modalID && !this.isCookie && !this.isLogin && !this.isNewCourses) {
            this._genericModalBroadcasterService.fire(GMBEventType.CLOSE, this.modalID);
            const bodyTag = document.body;
            bodyTag.classList.remove('open-modal');
        }
    }
}
